import AddCard from './AddCard';
import CardList from './CardList';

import SubMonthlyToYearly from './SubMonthlyToYearly';

export default function PaymentSection() {
  return (
    <div className="space-y-6">
      <AddCard />
      <SubMonthlyToYearly />
      <CardList />
    </div>
  );
}
